import { useEffect, useState } from 'react';
import { isFinePointerDevice } from '../utils/devicePointer';

const FINE_POINTER_QUERY = '(hover: hover) and (pointer: fine)';

/**
 * Desktop vs mobile: uses pointer/hover capabilities, not viewport width
 * (the app shell is always phone-width on PC too).
 */
export function useFinePointerDevice(): boolean {
  const [finePointer, setFinePointer] = useState(() => isFinePointerDevice());

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return;
    }
    const mq = window.matchMedia(FINE_POINTER_QUERY);
    const sync = () => setFinePointer(mq.matches);
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);

  return finePointer;
}
